module.exports = __webpack_public_path__ + "img/smile.ada9e0a2.png";